import { render, staticRenderFns } from "./HikVideoTestDialog.vue?vue&type=template&id=61365b70&scoped=true&"
import script from "./HikVideoTestDialog.vue?vue&type=script&lang=js&"
export * from "./HikVideoTestDialog.vue?vue&type=script&lang=js&"
import style0 from "./HikVideoTestDialog.vue?vue&type=style&index=0&id=61365b70&lang=scss&scoped=true&"
import style1 from "./HikVideoTestDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61365b70",
  null
  
)

export default component.exports